import React from 'react';
import './css/LegendaText.css';

const LegendaText = () => {
  return (
    <div className="legenda-container">
      <h3>🔖 Variáveis Disponíveis para o Texto do Modelo:</h3>
      <ul className="legenda-lista">
        <li><code>${'{nome}'}</code> — Nome completo do participante</li>
        <li><code>${'{cpf}'}</code> — CPF do participante</li>
        <li><code>${'{curso}'}</code> — Nome do curso</li>
        <li><code>${'{professor}'}</code> — Nome do professor</li>
        <li><code>${'{carga_horaria}'}</code> — Carga horária total</li>
        <li><code>${'{data_inicio}'}</code> — Data de início (DD/MM/AAAA)</li>
        <li><code>${'{data_fim}'}</code> — Data de término (DD/MM/AAAA)</li>
        <li><code>${'{data_emissao}'}</code> — Data de emissão do certificado</li>
      </ul>
      <p className="legenda-destaque">⚡ <strong>IMPORTANTE:</strong> Não esqueça de quebrar a linha, use <strong>Shift + Enter</strong>.</p>
    </div>
  );
};

export default LegendaText;
